import './tab-menu.scss';
import TabMenu from './TabMenu';

export default TabMenu;
export { default as TabMenuItem } from './TabMenuItem';
export { default as TabMenuItemBadge } from './TabMenuItemBadge';
